<template>
    <div class="login-footer-component-container">
        <div class="login-footer-component-wrapper">
            <div class="login-footer-container">
                <div class="fit20-logo-container">
                    <div class="back-to-login-page-btn-container">
                        <div v-if="$store.showFooterBackBtn" class="back-to-login-page-btn-wrapper"
                            @click="goToLoginPage">
                            <div class="back-arrow-img-container">
                                <img src="../../assets/icons/arrow_back.png" alt="Arrow Image">
                            </div>
                            <div class="text-container">
                                <!-- <p class="back-to-login-page-btn">
                                    Ga naar inlog
                                </p> -->
                                <p class="back-to-login-page-btn">
                                    {{ $t('go_to_login') }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="fit20-logo-wrapper">
                        <img src="../../assets/imgs/fit20_logo_footer.png" alt="fit20_logo">
                    </div>
                </div>
                <div class="select-lang-container">
                    <div class="select-lang-wrapper">
                        <div class="langs-list-container" :class="displayLangsList ? 'show' : 'hide'"
                            ref="langsListContainer">
                            <ul class="langs-list">
                                <li v-for="(langObj, index) in $store.appLangsArr"  :key=index class="lang" :class="{ 'last-lang': index === $store.appLangsArr.length - 1 }"
                                    @click="selectActiveLangHandle(langObj.countryCode)">
                                    <p>{{ langObj.language }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="active-lang-container" @click="showHideLangsList" ref="activeLangContainer">
                            <div class="active-lang-text-container">
                                <p class="active-lang-text">{{ $store.appLangsArr[$store.selectedAppLanguageIndex].language }}</p>
                                <!-- <p class="active-lang-text">{{ $store.selectedAppLanguage.toUpperCase() }}</p> -->
                            </div>
                            <div class="active-lang-img-container">
                                <img :src="require(`../../assets/icons/arrow_up.png`)"
                                    :class="displayLangsList ? 'arrow-down' : ''" alt="arrow_icon">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginFooter',
    data() {
        return {
            displayLangsList: false,
        }
    },
    methods: {
        showHideLangsList: function () {
            this.displayLangsList = !this.displayLangsList;
        },
        selectActiveLangHandle: async function(lang) {
            // console.log("lang: " + lang);
            // console.log("this.activeLang: " + this.activeLang);
            // console.log(this.$store.allLanguages);
            // if (lang !== this.$store.selectedAppLanguage.toUpperCase()) {
            //     // this.activeLang = lang;
            //     if (this.$store.allLanguages) {
            //         Object.keys(this.$store.allLanguages).some(key => {
            //             if (key === lang.toLowerCase()) {
            //                 this.$store.selectedAppLanguage = key;
            //                 this.$i18n.locale = key;
            //                 this.$i18n.setLocaleMessage(this.$i18n.locale, this.$store.allLanguages[this.$i18n.locale]);
            //                 return true; // This will stop the loop after the first match
            //             }
            //             return false; // Continue looping if no match is found
            //         });
            //     }
            // }
            if (lang.toLowerCase() !== this.$store.selectedAppLanguage) {
                this.$store.appLanguageChangedBeforeLogin = true;
                this.$store.changeAppLanguage(lang);
                // if (this.$store.requestSource.includes("webView")) {
                //     await window.flutter_change_app_language.postMessage(JSON.stringify({appLang: lang}));
                // }
            }
            this.displayLangsList = false;
        },
        handleDocumentClick: function (event) {
            const langsListContainer = this.$refs.langsListContainer;
            const activeLangContainer = this.$refs.activeLangContainer;

            if (
                langsListContainer &&
                !langsListContainer.contains(event.target) &&
                activeLangContainer &&
                !activeLangContainer.contains(event.target)
            ) {
                this.displayLangsList = false;
            }
        },
        goToLoginPage: function () {
            this.$store.backToLoginPage();
        },
    },
    mounted() {
        document.addEventListener('click', this.handleDocumentClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleDocumentClick);
    },
}
</script>

<style>
.login-footer-component-container {
    width: 100%;
    min-width: 280px;
    height: 35vw;
    max-height: 160px;
    position: relative;
    /* border: 1px solid red; */
}

.login-footer-component-container .login-footer-component-wrapper {
    width: 100%;
    height: 100%;
    /* border: 1px solid; */
}

.login-footer-component-container .login-footer-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    /* border: 1px solid blue; */
}

.login-footer-component-container .fit20-logo-container {
    width: 100%;
    height: 65%;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 5px 3px -5px #B6B6B6;
    /* border: 1px solid; */
}

[dir="rtl"] .login-footer-component-container .fit20-logo-container {
    direction: ltr;
}

.login-footer-component-container .back-to-login-page-btn-container {
    display: flex;
    justify-content: center;
    align-items: end;
    padding: 20px;
    /* border: 1px solid; */
}

.login-footer-component-container .back-to-login-page-btn-wrapper {
    height: max-content;
    display: flex;
    justify-content: center;
    align-items: end;
    cursor: pointer;
    /* border: 1px solid red; */
}

[dir="rtl"] .login-footer-component-container .back-to-login-page-btn-wrapper {
    align-items: center;
}

.login-footer-component-container .back-arrow-img-container {
    width: min(10px, 3vw);
    margin-right: 5px;
}

.login-footer-component-container .text-container p {
    color: #009df4;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 18px;
}

[dir="rtl"] .login-footer-component-container .text-container p {
    font-size: min(18px, calc(10px + 2vw));
}

.login-footer-component-container .back-arrow-img-container img {
    width: 100%;
}

.login-footer-component-container .fit20-logo-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: end;
    height: 100%;
    max-height: 105px;
    margin-bottom: -6px;
    /* border: 1px solid blue; */
}

.login-footer-component-container .fit20-logo-container img {
    height: min(100%, 18vw);
}

.login-footer-component-container .select-lang-container {
    /* flex: 1; */
    /* height: 30%; */
    /* width: 100%; */
    max-height: 35%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    /* border: 1px solid red; */
    padding: 15px 5px;
}

.login-footer-component-container .select-lang-wrapper {
    position: relative;
    width: min(170px, 40vw);
    cursor: pointer;
    /* border: 1px solid blue; */
}

.login-footer-component-container .active-lang-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-footer-component-container .active-lang-text {
    color: #a0a1a3;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: min(30px, calc(18px + 2vw));
    padding-right: 2px;
    /* border: 1px solid red; */
}

[dir="rtl"] .login-footer-component-container .active-lang-text {
    padding-left: 2px;
}

.login-footer-component-container .active-lang-img-container {
    width: 20px;
    /* height: 30px; */
    display: flex;
    justify-content: center;
    align-items: end;
}

.login-footer-component-container .active-lang-img-container img {
    width: 100%;
    transition: transform 0.3s ease;
}

.login-footer-component-container .active-lang-container .arrow-down {
    transform: rotate(180deg);
}

.login-footer-component-container .langs-list-container {
    /* width: 100%; */
    position: absolute;
    bottom: calc(100% + 2px);
    border: 2px solid #a0a1a3;
    border-radius: 5px;
    background: #ffffff;
}

.login-footer-component-container .langs-list li {
    max-height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: min(170px, 40vw);
    border-bottom: 1px solid #a0a1a3;
    overflow-y: hidden;
}

.login-footer-component-container .langs-list li p {
    padding: 10px 5px;
    color: #a0a1a3;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: min(30px, calc(18px + 2vw));
}

.login-footer-component-container .langs-list .last-lang {
    border-bottom: none;
}

.login-footer-component-container .langs-list li:hover {
    background: #009df4;
    color: #ffffff;
}

.login-footer-component-container .hide {
    visibility: hidden;
    bottom: 50%;
    transition: .3s ease-in;
}

.login-footer-component-container .show {
    opacity: 100%;
    transition: .3s ease-out;
}

@media (max-width: 425px) {
    .login-footer-component-container .text-container p {
        font-size: calc(10px + 1.6vw);
    }

    [dir="rtl"] .login-footer-component-container .text-container p {
        font-size: calc(10px + 1.6vw);
    }
}

@media (max-width: 320px) {
    .login-footer-component-container .text-container p {
        font-size: calc(9px + 1vw);
    }

    [dir="rtl"] .login-footer-component-container .text-container p {
        font-size: calc(9px + 1vw);
    }

    .login-footer-component-container .select-lang-container {
        padding: 15px 0 15px 5px;
    }

    .login-footer-component-container .active-lang-text,
    .login-footer-component-container .langs-list li {
        font-size: 24px;
    }

    .login-footer-component-container .langs-list li p {
        padding: 5px 0 5px 15px;
    }
}
</style>